import styled from 'styled-components/macro';
import { Row, Col } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';

const {
  spacing,
  custom_border_grey: customBorderGrey,
  media_lg: mediaLg,
  media_md: mediaMd,
  color_grey_900: colorGrey900,
  custom_slate: customSlate,
} = variables;

export const DetailsWrapper = styled('div')`
  border-radius: 6px;
  margin-bottom: ${spacing};
  background: #fff;
`;

export const AttributeWrapper = styled(Col)`
  margin-bottom: 30px;
  padding-right: 20px;
  &:last-child {
    * {
      border: none !important;
      padding-right: 0 !important;
    }
  }
`;
export const Attribute = styled('div')`
  padding-right: 30px;
  @media ${mediaMd} {
    border-right: 1px solid ${customBorderGrey};
  }
`;

export const AttributeRow = styled(Row)`
  margin-top: 30px;
  @media ${mediaLg} {
    margin-top: 30px;
  }
`;

export const AttributeRowRedesign = styled(Row)`
  div:last-child {
    margin-right: 0;
  }
`;

export const AttributeCol = styled(Col)`
  padding: 0;
  margin: 8px 5px;
  min-width: 150px;
  max-width: 150px;
`;

export const HeroCard = styled('div')`
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 16px #c0cff7;
  padding: 30px 50px;
  background-image: url(/images/book.svg);
  background-repeat: no-repeat;
  background-position: 70% 50%;
  background-size: 30%;
  min-height: 220px;
  @media (max-width: 575px) {
    background-image: none;
  }
  @media (max-width: 375px) {
    padding: 30px 10px;
  }
`;

export const AttributeCardRedesign = styled('div')`
  border: 1px solid ${colorGrey900};
  border-radius: 10px;
  box-shadow: 0 4px 8px ${colorGrey900};
  padding: 15px;
  min-height: 100%;
`;

export const FileWrapper = styled('div')`
  max-width: 350px;
  min-width: 250px;
  margin-bottom: 20px;
  margin-right: 20px;
`;

export const HeroTitle = styled('h1')`
  line-height: 32px;
  font-size: 26px;
  font-weight: 600;
  padding: 0 30px 20px;
  @media (max-width: 1024px) {
    line-height: 28px;
    font-size: 24px;
  }
  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 24px;
    padding: 0 10px 15px;
  }
`;

export const HeroDescription = styled('div')`
  font-size: 14px;
  color: ${customSlate};
  padding: 0 30px 30px;
  line-height: 22px !important;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    font-size: 12px;
    padding: 0 10px 15px;
  }
  @media (max-width: 425px) {
    padding-bottom: 0;
  }
`;
